export default {
  attendancepolicyname: {
    header: "Policy Name & Description",
    headercss: "vmHeader",
    subheader: "Policy name",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  description: {
    header: "",
    headercss: "vmHeader",
    subheader:
      "Internal description for other admins who would view this setting",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  iswfh: {
    header: "Working Request",
    headercss: "vmHeader",
    subheader:
      "Do you want to allow employees to apply Work From Home, Work From Office or Out Duty attendance request?",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  wfhlimit: {
    header: "",
    headercss: "vmHeader",
    subheader:
      "Restriction on number of Work from home requests employees can apply:",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  iswfo: {
    header: "",
    headercss: "vmHeader",
    subheader: "Is Work from office Clock-in request allowed?",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  wfolimit: {
    header: "",
    headercss: "vmHeader",
    subheader:
      "Restriction on number of Work from office requests employees can apply:",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  isoutduty: {
    header: "",
    headercss: "vmHeader",
    subheader: "Is Out Duty Clock-in request allowed?",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  outdutylimit: {
    header: "",
    headercss: "vmHeader",
    subheader:
      "Restriction on number of Out Duty requests employees can apply:",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  restrictattendancereqlimit: {
    header: "",
    headercss: "vmHeader",
    subheader:
      "Restriction on number of Attedance requests employees can apply per month:",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  isabsenteeismrule: {
    header: "Absenteeism",
    headercss: "vmHeader",
    subheader:
      "Do you wish to take auto-actions when an employee's logs are not available for a day?",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  absenteeismtypeid: [
    {
      1: {
        header: "",
        headercss: "vmHeader",
        subheader:
          "How would you like us to handle No-show situations, when employees don’t clock-in for the day and haven’t applied for any Leave request either?",
        subheadercss: "vmSubHeader",
        values:
          "Assume employee forgot to clock attendance, and take following attendance action after the shift cut-off time",
      },
      2: {
        header: "",
        headercss: "vmHeader",
        subheader:
          "How would you like us to handle No-show situations, when employees don’t clock-in for the day and haven’t applied for any Leave request either?",
        subheadercss: "vmSubHeader",
        values:
          "Assume employee was on Leave, and take following leave action after shift cut-off time",
      },
    },
  ],
  absenteeismactionid: [
    {
      1: {
        dependent: "absenteeismtypeid",
        header: "",
        headercss: "vmHeader",
        subheader: "",
        subheadercss: "vmSubHeader",
        values: [
          {
            "#1": "Create an attendance request on behalf of the employee (based on employee’s assigned shift timings)",
          },
          { "#2": "Create a leave request on behalf of the employee" },
        ],
      },
      2: {
        dependent: "absenteeismtypeid",
        header: "",
        headercss: "vmHeader",
        subheader: "",
        subheadercss: "vmSubHeader",
        values: [
          {
            "#1": "Update the attendance logs based on employee’s assigned shift timings and send a notification to Employee, Approvers & Admin.",
          },
          { "#2": "Automatically deduct the employee's leave" },
        ],
      },
    },
  ],
  absenteeismleaveid: null,
  absenteeismleavename: {
    header: "",
    headercss: "vmHeader",
    subheader: "Absenteeism Leave Type",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  absenteeismleavecount: {
    header: "",
    headercss: "vmHeader",
    subheader: "",
    subheadercss: "vmSubHeader",
    values: "Number of leaves to deduct: <val>",
  },
  ispunctualityrule: {
    header: "Punctuality",
    headercss: "vmHeader",
    subheader:
      "Do you wish to identify/track or penalize late-comers in any way?",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  istimeatworkrule: {
    header: "Time at work",
    headercss: "vmHeader",
    subheader:
      "Do you wish to set time at work requirements for your company? Here you can specify number of hours an employee needs to be at-work in order to meet the company’s attendance expectations.",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  attendancepunctualityid: 29,
  attendancepolicyid: 31,
  punctualitytypeid: [
    {
      1: {
        header: "",
        headercss: "vmHeader",
        subheader: "",
        subheadercss: "vmSubHeader",
        values: "Late marks will be counted on exceeding grace hours",
      },
      2: {
        header: "",
        headercss: "vmHeader",
        subheader: "",
        subheadercss: "vmSubHeader",
        values: "Late marks will be counted on usage of grace counts",
      },
    },
  ],
  gracehourtime: {
    header: "",
    headercss: "vmHeader",
    subheader: "",
    subheadercss: "vmSubHeader",
    values: "Monthly grace hours employees get is: <val> hr:min",
  },
  penaltytypeid: [
    {
      1: {
        dependent: "punctualitytypeid",
        header: "",
        headercss: "vmHeader",
        subheader: [
          {
            "#1": "What will be the penalty on late-marks after exhausting the Grace hours",
          },
          {
            "#2": "What will be the penalty after exceeding the grace counts available in a month?",
          },
        ],
        subheadercss: "vmSubHeader",
        values: [
          {
            "#1": "Deduct leaves and refill grace hours back to full capacity",
          },
          {
            "#2": "Deduct leaves and refill the grace counts back to full capacity",
          },
        ],
      },
      2: {
        dependent: "punctualitytypeid",
        header: "",
        headercss: "vmHeader",
        subheader: [
          {
            "#1": "What will be the penalty on late-marks after exhausting the Grace hours",
          },
          {
            "#2": "What will be the penalty after exceeding the grace counts available in a month?",
          },
        ],
        subheadercss: "vmSubHeader",
        values: [
          {
            "#1": "Deduct leaves but do not refill grace hours, and consider every following Late-Mark eligible for deduction too (till month end), as per below:",
          },
          {
            "#2": "Deduct leaves but do not refill grace counts, and consider every following breach as a Late-Mark eligible for deduction too (till month end), as per below:",
          },
        ],
      },
      3: {
        dependent: "punctualitytypeid",
        header: "",
        headercss: "vmHeader",
        subheader: [
          {
            "#1": "What will be the penalty on late-marks after exhausting the Grace hours",
          },
          {
            "#2": "What will be the penalty after exceeding the grace counts available in a month?",
          },
        ],
        subheadercss: "vmSubHeader",
        values: [
          {
            "#1": "No penalty or deductions for exhausting Grace hours. Just record the Late-Marks based on the Grace hours configured.",
          },
          {
            "#2": "No penalty or deductions for exhausting Grace counts. Just record the Late-Marks based on the grace count's configured breach-time limit.",
          },
        ],
      },
    },
  ],
  penaltyleaveid: 24,
  penaltyleavename: {
    header: "",
    headercss: "vmHeader",
    subheader: "Leave Type",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  penaltyleavecount: {
    header: "",
    headercss: "vmHeader",
    subheader: "",
    subheadercss: "vmSubHeader",
    values: "Number of leaves to deduct: <val>",
  },
  penaltyactiontypeid: [
    {
      1: {
        header: "",
        headercss: "vmHeader",
        subheader: "Deduction Policy",
        subheadercss: "vmSubHeader",
        values: "Deduct automatically and notify employee, approvers and admin",
      },
      2: {
        header: "",
        headercss: "vmHeader",
        subheader: "Deduction Policy",
        subheadercss: "vmSubHeader",
        values:
          "Automatically send a leave request on behalf of the employee, using the leave approval workflow",
      },
    },
  ],
  gracedaycount: {
    header: "",
    headercss: "vmHeader",
    subheader: "",
    subheadercss: "vmSubHeader",
    values: "Number of grace counts available in a month is: <val>",
  },
  gracetime: {
    header: "",
    headercss: "vmHeader",
    subheader: "Each grace count must trigger after: ",
    subheadercss: "vmSubHeader",
    values: " <val>",
  },
  gracetimelimit: {
    header: "",
    headercss: "vmHeader",
    subheader: "but must not exceed max limit of: ",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  exceedgracedaycount: {
    header: "",
    headercss: "vmHeader",
    subheader: "",
    subheadercss: "vmSubHeader",
    values:
      "Exceeding max limit will be considered as additional <val> grace count usage",
  },
  breachleavecount: {
    header: "",
    headercss: "vmHeader",
    subheader: "",
    subheadercss: "vmSubHeader",
    values:
      "<val> Number of leaves to deduct per Late day after the first time",
  },
  attendancetimeatworkid: 30,

  isforday: {
    header: "",
    headercss: "vmHeader",
    subheader: "Employees are required to work minimum hours, every day",
    subheadercss: "vmSubHeader",
    values:
      "<val> Number of leaves to deduct per Late day after the first time",
  },
  isforhalfday: {
    header: "",
    headercss: "vmHeader",
    subheader: "",
    subheadercss: "vmSubHeader",
    values:
      "Required time-at-work or hours for Half-working day, and penalty (if any) in case of dificit",
  },
  halfdayinhours: {
    header: "",
    headercss: "vmHeader",
    subheader: "",
    subheadercss: "vmSubHeader",
    values:
      "Minimum duration required to count the work-day as a Half day <val> Hours",
  },
  halfdayinpercentage: {
    header: "",
    headercss: "vmHeader",
    subheader: "",
    subheadercss: "vmSubHeader",
    values:
      "Minimum duration required to count the work-day as a Half day <val> % of Shift’s total duration",
  },
  ishalfdaypenalty: {
    header: "",
    headercss: "vmHeader",
    subheader:
      "Do you want to deduct leaves as penalty if the employee is unable to complete the required minimum hours for Half-working day?",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  halfdayleaveid: null,
  halfdayleavename: {
    header: "",
    headercss: "vmHeader",
    subheader: "Leave Type",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  halfdayleavecount: {
    header: "",
    headercss: "vmHeader",
    subheader: "",
    subheadercss: "vmSubHeader",
    values: "Number of leaves to deduct: <val>",
  },
  halfdaypenaltyactiontypeid: [
    {
      1: {
        header: "",
        headercss: "vmHeader",
        subheader: "Deduction Policy",
        subheadercss: "vmSubHeader",
        values:
          "Automatically send a leave request on behalf of the employee, using the regular Leave approval workflow",
      },
      2: {
        header: "",
        headercss: "vmHeader",
        subheader: "Deduction Policy",
        subheadercss: "vmSubHeader",
        values: "Deduct automatically and notify employee, approvers and admin",
      },
    },
  ],
  isforfullday: {
    header: "",
    headercss: "vmHeader",
    subheader:
      "Required time-at-work or hours for Full-working day, and penalty (if any) in case of deficit",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  fulldayinhours: {
    header: "",
    headercss: "vmHeader",
    subheader: "",
    subheadercss: "vmSubHeader",
    values:
      "Minimum duration required to count the work-day as a Full day <val> Hours",
  },
  fulldayinpercentage: {
    header: "",
    headercss: "vmHeader",
    subheader: "",
    subheadercss: "vmSubHeader",
    values:
      "Minimum duration required to count the work-day as a Full day <val> % of Shift’s total duration",
  },
  isfulldaypenalty: {
    header: "",
    headercss: "vmHeader",
    subheader:
      "Do you want to deduct leaves as penalty if the employee is unable to complete the required minimum hours for Full-working day?",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  fulldayleaveid: null,
  fulldayleavename: {
    header: "",
    headercss: "vmHeader",
    subheader: "Leave type to deduct",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  fulldayleavecount: {
    header: "",
    headercss: "vmHeader",
    subheader: "",
    subheadercss: "vmSubHeader",
    values: "Number of leaves to deduct: <val>",
  },
  fulldaypenaltyactiontypeid: [
    {
      1: {
        header: "",
        headercss: "vmHeader",
        subheader: "Deduction Policy",
        subheadercss: "vmSubHeader",
        values:
          "Automatically send a leave request on behalf of the employee, using the regular Leave approval workflow",
      },
      2: {
        header: "",
        headercss: "vmHeader",
        subheader: "Deduction Policy",
        subheadercss: "vmSubHeader",
        values: "Deduct automatically and notify employee, approvers and admin",
      },
    },
  ],
  isforweekly: {
    header: "",
    headercss: "vmHeader",
    subheader: "Employees are required to work minimum hours, every week",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  weeklyhours: {
    header: "",
    headercss: "vmHeader",
    subheader: "",
    subheadercss: "vmSubHeader",
    values:
      "Required time-at-work or hours for one week, and penalty (if any) in case of deficit <val> Hours",
  },
  isweeklypenalty: {
    header: "",
    headercss: "vmHeader",
    subheader:
      "Do you want to deduct leaves as penalty if the employee is unable to complete the required minimum hours?",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  weeklyleaveid: null,
  weeklyleavename: {
    header: "",
    headercss: "vmHeader",
    subheader: "Leave type to deduct",
    subheadercss: "vmSubHeader",
    values: "<val>",
  },
  weeklyleavecount: {
    header: "",
    headercss: "vmHeader",
    subheader: "",
    subheadercss: "vmSubHeader",
    values: "Number of leaves to deduct: <val>",
  },
  weeklypenaltyactiontypeid: [
    {
      1: {
        header: "",
        headercss: "vmHeader",
        subheader: "Deduction Policy",
        subheadercss: "vmSubHeader",
        values:
          "Automatically send a leave request on behalf of the employee, using the regular Leave approval workflow",
      },
      2: {
        header: "",
        headercss: "vmHeader",
        subheader: "Deduction Policy",
        subheadercss: "vmSubHeader",
        values: "Deduct automatically and notify employee, approvers and admin",
      },
    },
  ],
  isformonthly: false,
  monthlyhours: "00:00",
  ismonthlypenalty: null,
  monthlyleaveid: null,
  monthlyleavename: null,
  monthlyleavecount: null,
  monthlypenaltyactiontypeid: null,
};
